import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SplitScreenImages = ({ leftImage, rightImage }) => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    <div ref={ref} className="grid md:grid-cols-2 gap-8 h-[600px]">
      {/* Left Image - Slide in from left */}
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
        transition={{ duration: 1, ease: [0.6, 0.05, 0.01, 0.9] }}
        className="relative overflow-hidden group cursor-pointer"
      >
        <motion.img
          src={leftImage.url}
          alt={leftImage.alt}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.1, rotate: 2 }}
          transition={{ duration: 0.6 }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-dark/60 via-transparent to-transparent group-hover:opacity-0 transition-opacity duration-500" />
        
        {leftImage.caption && (
          <motion.div 
            className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-navy-dark to-transparent"
            initial={{ y: 20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : { y: 20, opacity: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            <h3 className="text-2xl font-bold text-white">{leftImage.caption}</h3>
          </motion.div>
        )}
      </motion.div>

      {/* Right Image - Slide in from right */}
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        animate={inView ? { x: 0, opacity: 1 } : { x: 100, opacity: 0 }}
        transition={{ duration: 1, delay: 0.2, ease: [0.6, 0.05, 0.01, 0.9] }}
        className="relative overflow-hidden group cursor-pointer"
      >
        <motion.img
          src={rightImage.url}
          alt={rightImage.alt}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.1, rotate: -2 }}
          transition={{ duration: 0.6 }}
        />
        <div className="absolute inset-0 bg-gradient-to-bl from-navy-dark/60 via-transparent to-transparent group-hover:opacity-0 transition-opacity duration-500" />
        
        {rightImage.caption && (
          <motion.div 
            className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-navy-dark to-transparent"
            initial={{ y: 20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : { y: 20, opacity: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            <h3 className="text-2xl font-bold text-white">{rightImage.caption}</h3>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

export default SplitScreenImages;
